var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#6359E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 12C17.1863 12 15.1073 13.017 13.4591 14.2028C11.8023 15.3948 10.4862 16.8251 9.67489 17.8102C8.77504 18.9027 8.77504 20.4492 9.67488 21.5417C10.4862 22.5267 11.8023 23.957 13.4591 25.1491C15.1073 26.3349 17.1863 27.3519 19.5 27.3519C21.8137 27.3519 23.8927 26.3349 25.5409 25.1491C27.1977 23.957 28.5138 22.5267 29.3251 21.5417C30.225 20.4492 30.225 18.9027 29.3251 17.8102C28.5138 16.8251 27.1977 15.3949 25.5409 14.2028C23.8927 13.017 21.8137 12 19.5 12ZM19.4998 17.4828C18.2886 17.4828 17.3067 18.4647 17.3067 19.6759C17.3067 20.8872 18.2886 21.8691 19.4998 21.8691C20.711 21.8691 21.6929 20.8872 21.6929 19.6759C21.6929 18.4647 20.711 17.4828 19.4998 17.4828ZM15.1136 19.6759C15.1136 17.2535 17.0773 15.2897 19.4998 15.2897C21.9223 15.2897 23.8861 17.2535 23.8861 19.6759C23.8861 22.0984 21.9223 24.0622 19.4998 24.0622C17.0773 24.0622 15.1136 22.0984 15.1136 19.6759Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon2);
export default __webpack_public_path__ + "static/media/dash-icon-2.75568feb84f09e607dc7e40253619c81.svg";
export { ForwardRef as ReactComponent };